// import axios from "axios";
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../Login/login.css";
// import Swal from "sweetalert2";

// const ForgotPassword = () => {
//   const [newpassword, setnewpassword] = useState(""); // State for email
//   const [confirmpassword, setPassword] = useState(""); // State for password
//   const navigate = useNavigate(); // Initialize useNavigate

//   const showAutoCloseAlert = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "success",
//       title: message,
//       showConfirmButton: false,
//       timer: 1500,
//     });
//   };

//   const showAutoError = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: message,
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault(); // Prevent default form submission
//     try {
//       const response = await axios.post(
//         "https://toptennis.io/api/user/login",
//         {
//           newpassword,
//           confirmpassword,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200 && response.data.token) {
//         // Save the token to localStorage with the key 'user_token'
//         localStorage.setItem("user_token", response.data.token);
//         showAutoCloseAlert("Create New Password Successfully", response.data)
//         // If login is successful, navigate to the home page
//         navigate("/");
//       } else {
//         // Handle error responses
//         showAutoError("New Password Create failed", response.data);
//       }
//     } catch (error) {
//       showAutoError("Invalid password – please try again ");
//     }
//   };
// const handleUpdatePassword = async () => {
//   if (newpassword !== confirmpassword) {
//     setPasswordError("Passwords do not match.");
//     return;
//   }

//   // Check if password length is exactly 12 characters
//   if (newpassword.length !== 12 || confirmpassword.length !== 12) {
//     setPasswordError("Passwords must be exactly 12 characters long.");
//     return;
//   }

//   setPasswordError(""); // Clear any existing errors
//   try {
//     const response = await axios.patch("https://toptennis.io/api/user/forgotPassword", {
//       email,
//       newPassword: newpassword,
//       confirmPassword: confirmpassword,
//     });
//     if (response.status === 200) {
//       showAutoCloseAlert("Password successfully updated.");
//       navigate("/");
//     }
//   } catch (error) {
//     showAutoError("Failed to reset password. Please try again.");
//   }
// };






//   return (
//     <>
//       <div
//         className="modal fade show"
//         id="formModal"
//         tabIndex="-1"
//         aria-labelledby="contained-modal-title-vcenter"
//         role="dialog"
//         aria-hidden="true"
//         style={{ display: "block" }}
//       >
//         <div
//           className="modal-dialog modal-dialog-centered modal-bottom"
//           role="document"
//         >
//           <div
//             className="modal-content"
//             style={{ backgroundColor: "black", marginBottom: "0" }}
//           >
//             <div className="modal-header">
//               <h5
//                 className="modal-title"
//                 id="formModalLabel"
//                 style={{ color: "white" }}
//               >
//                 Forgot Password
//               </h5>
//             </div>
//             <div className="modal-body1" style={{ padding: "30px" }}>
//               <form onSubmit={handleSubmit}>
//                 <div className="input-container">
//                   <input
//                     type="password"
//                     required
//                     placeholder="Enter New Password"
//                     value={newpassword}
//                     onChange={(e) => setnewpassword(e.target.value)} // Update state on input change
//                   />
//                   <label>New Password</label>
//                 </div>
//                 <div className="input-container">
//                   <input
//                     type="password"
//                     required
//                     placeholder="Enter Confirm Password"
//                     value={confirmpassword}
//                     onChange={(e) => setPassword(e.target.value)} // Update state on input change
//                   />
//                   <label>Confirm Password</label>
//                 </div>
//                 <button type="submit" className="btn">
//                   Continue
//                 </button>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="box">
//       <form onSubmit={handleSubmit}>
//                 <div className="input-container">
//                   <input
//                     type="password"
//                     required
//                     placeholder="Enter New Password"
//                     value={newpassword}
//                     onChange={(e) => setnewpassword(e.target.value)} // Update state on input change
//                   />
//                   <label>New Password</label>
//                 </div>
//                 <div className="input-container">
//                   <input
//                     type="password"
//                     required
//                     placeholder="Enter Confirm Password"
//                     value={confirmpassword}
//                     onChange={(e) => setPassword(e.target.value)} // Update state on input change
//                   />
//                   <label>Confirm Password</label>
//                 </div>
//                 <button type="submit" className="btn">
//                   Continue
//                 </button>
//               </form>
//       </div>


//     </>
//   );
// };

// export default ForgotPassword;

// import axios from "axios";
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../forgot-password/forgotpassword.css";
// import Swal from "sweetalert2";

// const ForgotPassword = () => {
//   const [email, setEmail] = useState(""); // State for email
//   const [newpassword, setNewPassword] = useState(""); // State for new password
//   const [confirmpassword, setConfirmPassword] = useState(""); // State for confirm password
//   const [otp, setOtp] = useState(""); // State for OTP input
//   const [isOtpSent, setIsOtpSent] = useState(false); // Flag to check if OTP is sent
//   const navigate = useNavigate(); // Initialize useNavigate

//   const showAutoCloseAlert = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "success",
//       title: message,
//       showConfirmButton: false,
//       timer: 1500,
//     });
//   };

//   const showAutoError = (message) => {
//     Swal.fire({
//       position: "top-end",
//       icon: "error",
//       title: message,
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault(); // Prevent default form submission

//     if (isOtpSent) {
//       // If OTP is already sent, submit OTP along with other details
//       try {
//         const response = await axios.patch(
//           "https://toptennis.io/api/user/forgotPassword",
//           {
//             email,
//             newPassword: newpassword,
//             confirmPassword: confirmpassword,
//             OTP: otp,
//           },
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (response.status === 200) {
//           showAutoCloseAlert("Password successfully updated.");
//           navigate("/"); // Navigate to homepage after successful password reset
//         } else {
//           showAutoError("Failed to update password.");
//         }
//       } catch (error) {
//         showAutoError("Invalid OTP or password reset failed.");
//       }
//     } else {
//       // If OTP is not sent yet, trigger OTP sending
//       try {
//         const response = await axios.post(
//           "https://toptennis.io/api/user/otp",
//           { email },
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (response.status === 200) {
//           setIsOtpSent(true); // Mark OTP as sent
//           showAutoCloseAlert("OTP sent to your email. Please check.");
//         } else {
//           showAutoError("Failed to send OTP.");
//         }
//       } catch (error) {
//         showAutoError("Failed to send OTP.");
//       }
//     }
//   };

//   return (
//     <>
//       <div
//         className="modal fade show"
//         id="formModal"
//         tabIndex="-1"
//         aria-labelledby="contained-modal-title-vcenter"
//         role="dialog"
//         aria-hidden="true"
//         style={{ display: "block" }}
//       >
//         <div className="modal-dialog modal-dialog-centered modal-bottom" role="document">
//           <div className="modal-content" style={{ backgroundColor: "black", marginBottom: "0" }}>
//             <div className="modal-header">
//               <h5 className="modal-title" id="formModalLabel" style={{ color: "white" }}>
//                 Forgot Password
//               </h5>
//             </div>
//             <div className="modal-body1" style={{ padding: "30px" }}>
//               <form onSubmit={handleSubmit}>
//                 {!isOtpSent ? (
//                   // Form to enter email, new password, and confirm password
//                   <>
//                     <div className="input-container">
//                       <input
//                         type="email"
//                         required
//                         placeholder="Enter Email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                       />
//                       <label>Email</label>
//                     </div>
//                     <div className="input-container">
//                       <input
//                         type="password"
//                         required
//                         placeholder="Enter New Password"
//                         value={newpassword}
//                         onChange={(e) => setNewPassword(e.target.value)}
//                       />
//                       <label>New Password</label>
//                     </div>
//                     <div className="input-container">
//                       <input
//                         type="password"
//                         required
//                         placeholder="Confirm Password"
//                         value={confirmpassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                       />
//                       <label>Confirm Password</label>
//                     </div>
//                     <button type="submit" className="btn">
//                       Continue
//                     </button>
//                   </>
//                 ) : (
//                   // Form to enter OTP after sending OTP
//                   <>
//                     <div className="input-container">
//                       <input
//                         type="text"
//                         required
//                         maxLength={6}
//                         placeholder="Enter OTP"
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                       />
//                       <label>OTP</label>
//                     </div>
//                     <button type="submit" className="btn">
//                       Submit OTP
//                     </button>
//                   </>
//                 )}
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//              <div className="box1">
//           <form onSubmit={handleSubmit}>
//                 {!isOtpSent ? (
//                   // Form to enter email, new password, and confirm password
//                   <>
//                     <div className="input-container">
//                       <input
//                         type="email"
//                         required
//                         placeholder="Enter Email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                       />
//                       <label>Email</label>
//                     </div>
//                     <div className="input-container">
//                       <input
//                         type="password"
//                         required
//                         placeholder="Enter New Password"
//                         value={newpassword}
//                         onChange={(e) => setNewPassword(e.target.value)}
//                       />
//                       <label>New Password</label>
//                     </div>
//                     <div className="input-container">
//                       <input
//                         type="password"
//                         required
//                         placeholder="Confirm Password"
//                         value={confirmpassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                       />
//                       <label>Confirm Password</label>
//                     </div>
//                     <button type="submit" className="btn1">
//                       Continue
//                     </button>
//                   </>
//                 ) : (
//                   // Form to enter OTP after sending OTP
//                   <>
//                     <div className="input-container">
//                       <input
//                         type="text"
//                         required
//                         maxLength={6}
//                         placeholder="Enter OTP"
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                       />
//                       <label>OTP</label>
//                     </div>
//                     <button type="submit" className="btn">
//                       Submit OTP
//                     </button>
//                   </>
//                 )}
//               </form>
//        </div>


//     </>
//   );
// };

// export default ForgotPassword;




import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../forgot-password/forgotpassword.css";
import Swal from "sweetalert2";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const showAutoCloseAlert = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const showAutoError = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  };

  const handleSendOtp = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post("https://toptennis.io/api/user/otp", { email });
      if (response.status === 200) {
        setIsOtpSent(true);
        showAutoCloseAlert("OTP sent to your email. Please check.");
      }
    } catch (error) {
      showAutoError("Failed to send OTP. Please try again.");
    }
    setIsLoading(false);
  };

  const handleVerifyOtp = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post("https://toptennis.io/api/user/otpverified", { OTP: otp });
      if (response.status === 200) {
        setIsOtpVerified(true);
        showAutoCloseAlert("OTP verified. You can now reset your password.");
      } else {
        showAutoError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      showAutoError("OTP verification failed. Please try again.");
    }
    setIsLoading(false);

  };


  const handleUpdatePassword = async () => {
    if (newpassword !== confirmpassword) {
      setPasswordError("Passwords do not match.");
      return;
    }

    // Check if password length is within the limit of 12 characters
    if (newpassword.length > 12 || confirmpassword.length > 12) {
      setPasswordError("Passwords must be 12 characters or fewer.");
      return;
    }

    setPasswordError(""); // Clear any existing errors
    setIsUpdating(true);

    try {
      const response = await axios.patch("https://toptennis.io/api/user/forgotPassword", {
        email,
        newPassword: newpassword,
        confirmPassword: confirmpassword,
      });
      if (response.status === 200) {
        showAutoCloseAlert("Password successfully updated.");
        navigate("/");
      }
    } catch (error) {
      showAutoError("Failed to reset password. Please try again.");
    }
    setIsUpdating(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isOtpSent) {
      handleSendOtp();
    } else if (!isOtpVerified) {
      handleVerifyOtp();
    } else {
      handleUpdatePassword();
    }
  };

  const handleLogin = () => {
    navigate("/");
  }

  return (
    <>
      <div
        className="modal fade show"
        id="formModal"
        tabIndex="-1"
        aria-labelledby="contained-modal-title-vcenter"
        role="dialog"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-bottom" role="document">
          <div className="modal-content" style={{ backgroundColor: "black", marginBottom: "0" }}>
            <div className="modal-header">
              <h5 className="modal-title" id="formModalLabel" style={{ color: "white" }}>
                Forgot your password?
              </h5>
            </div>
            <div className="modal-body1" style={{ padding: "30px" }}>
              <form onSubmit={handleSubmit}>
                {!isOtpSent ? (
                  <>
                    <div className="input-container">
                      <input
                        type="email"
                        required
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label>Email</label>
                    </div>
                    {/* <button type="submit" className="btn">
                      Continue
                    </button> */}
                    <button type="submit" className="btn" disabled={isLoading}>
                      {isLoading ? <span className="spinner"></span> : "Continue"}
                    </button>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px"
                      }}
                    >
                      <button
                        onClick={handleLogin}
                        style={{
                          background: "none",
                          color: "lightblue",
                          border: "none",
                          cursor: "pointer",
                          textAlign: "center",
                          fontSize: "18px"
                        }}
                      >
                        Back To Login
                      </button>
                    </div>


                  </>
                ) : !isOtpVerified ? (
                  <>
                    <div className="input-container">
                      <input
                        type="text"
                        required
                        maxLength={6}
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                      <label>OTP</label>
                    </div>
                    <button type="submit" className="btn" disabled={isLoading}>
                      {isLoading ? <span className="spinner"></span> : "Submit OTP"}
                    </button>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px"
                      }}
                    >
                      <button
                        onClick={handleLogin}
                        style={{
                          background: "none",
                          color: "lightblue",
                          border: "none",
                          cursor: "pointer",
                          textAlign: "center",
                          fontSize: "18px"
                        }}
                      >
                        Back To Login
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="input-container">
                      <input
                        type="password"
                        required
                        placeholder="Enter New Password"
                        value={newpassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        maxLength={12} // Ensures input cannot exceed 12 characters
                      />
                      <label>New Password</label>
                    </div>
                    <div className="input-container">
                      <input
                        type="password"
                        required
                        placeholder="Confirm Password"
                        value={confirmpassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        maxLength={12} // Ensures input cannot exceed 12 characters
                      />
                      <label>Confirm Password</label>
                    </div>
                    {passwordError && (
                      <span style={{ color: "red", fontSize: "12px" }}>{passwordError}</span>
                    )}
                    <button type="submit" className="btn" onClick={handleUpdatePassword} disabled={isUpdating}>
                      {isUpdating ? <span className="spinner"></span> : "Update Password"}
                    </button>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal">
        <div className="box1">
          <form onSubmit={handleSubmit}>
            {!isOtpSent ? (
              <>
                <div className="input-container">
                  <input
                    type="email"
                    required
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <label>Email</label>
                </div>
                <button type="submit" className="btn" disabled={isLoading}>
                  {isLoading ? <span className="spinner"></span> : "Continue"}
                </button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px"
                  }}
                >
                  <button
                    onClick={handleLogin}
                    style={{
                      background: "none",
                      color: "lightblue",
                      border: "none",
                      cursor: "pointer",
                      textAlign: "center",
                      fontSize: "18px"
                    }}
                  >
                    Back To Login
                  </button>
                </div>
              </>
            ) : !isOtpVerified ? (
              <>
                <div className="input-container">
                  <input
                    type="text"
                    required
                    maxLength={6}
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <label>OTP</label>
                </div>
                <button type="submit" className="btn" disabled={isLoading}>
                  {isLoading ? <span className="spinner"></span> : "Submit OTP"}
                </button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "10px"
                  }}
                >
                  <button
                    onClick={handleLogin}
                    style={{
                      background: "none",
                      color: "lightblue",
                      border: "none",
                      cursor: "pointer",
                      textAlign: "center",
                      fontSize: "18px"
                    }}
                  >
                    Back To Login
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="input-container">
                  <input
                    type="password"
                    required
                    placeholder="Enter New Password"
                    value={newpassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    maxLength={12} // Ensures input cannot exceed 12 characters
                  />
                  <label>New Password</label>
                </div>
                <div className="input-container">
                  <input
                    type="password"
                    required
                    placeholder="Confirm Password"
                    value={confirmpassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    maxLength={12} // Ensures input cannot exceed 12 characters
                  />
                  <label>Confirm Password</label>
                </div>
                {passwordError && (
                  <span style={{ color: "red", fontSize: "12px" }}>{passwordError}</span>
                )}
                <button type="submit" className="btn" onClick={handleUpdatePassword} disabled={isUpdating}>
                  {isUpdating ? <span className="spinner"></span> : "Update Password"}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;